export class FilesService {
    /**
     * Descarga un archivo a partir de un blob con el nombre deseado.
     * @param base64Data - Contenido del archivo en Base64
     * @param fileName - Nombre del archivo a descargar (incluye la extensión .txt)
     */
    public downloadFileFromBlob(blob: Blob, fileName: string): void {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    }

    /**
     * Descarga un fichero txt a partir de un Base64 con el nombre deseado.
     * @param base64Data - Contenido del archivo en Base64
     * @param fileName - Nombre del archivo a descargar (incluye la extensión .txt)
     */
    public downloadTxtFromBase64(base64Data: string, fileName: string): void {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'text/plain' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(link.href);
    }
}
